var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-container",
      class: [
        _vm.expanded == true ? "expanded" : "",
        _vm.selectedAddonProducts.length > 0 ? "hasProduct" : "",
        _vm.isSticking ? "sticky" : "",
        _vm.step > 1 ? "global" : ""
      ],
      on: {
        click: function($event) {
          return _vm.expandCart(false)
        }
      }
    },
    [
      _vm.expanded == false
        ? _c(
            "div",
            {
              staticClass: "unexpanded-cart",
              class: _vm.isSticking ? "sticking" : "",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "expand-arrow",
                  on: {
                    click: function($event) {
                      return _vm.expandCart(true)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("Expand")]),
                  _vm._v("\n          <\n      ")
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { id: "cart-header" } }, [
                _c("div", { staticClass: "price-container" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Price per Box")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "price" }, [
                    _vm._v(_vm._s(_vm._f("moneySaleFormat")(_vm.totalPrice)))
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "qty-box-title" }, [
                  _vm._v("Qty of Boxes:")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedBoxQty,
                        expression: "selectedBoxQty"
                      }
                    ],
                    attrs: { id: "boxqtyselector" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedBoxQty = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.changeBoxQty(null)
                        }
                      ]
                    }
                  },
                  _vm._l(_vm.boxMaxQty, function(qty) {
                    return _c(
                      "option",
                      { key: qty, domProps: { value: qty } },
                      [_vm._v(_vm._s(qty))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("p", { staticClass: "products-container-title" }, [
                  _vm._v("Your Gift:")
                ])
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "products-container no-scrollbar scrollList",
                  attrs: { id: "products-scroll-container" },
                  on: { scroll: _vm.handleScroll }
                },
                [
                  _vm._l(_vm.selectedAddonProducts, function(
                    addonProduct,
                    index
                  ) {
                    return _c(
                      "li",
                      {
                        key: addonProduct.variants[0].id,
                        class: _vm.isOverflow(addonProduct)
                          ? "overflow-product"
                          : "",
                        attrs: { id: "product-" + index }
                      },
                      [
                        !_vm.extendedAlert &&
                        _vm.isExtendedBoxes &&
                        _vm.extendedProducts.includes(addonProduct.title) &&
                        _vm.step == 2 &&
                        !_vm.isOverflow(addonProduct)
                          ? _c("div", { staticClass: "alert-overlay" }, [
                              _c("img", {
                                staticClass: "alert-icon",
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/i_icon_554a1a74-64ad-404e-9f6e-47fe1431b3ea.svg?v=1753797241"
                                },
                                on: {
                                  click: function() {
                                    _vm.extendedAlert = true
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.extendedAlert &&
                        _vm.isExtendedBoxes &&
                        _vm.extendedProducts.includes(addonProduct.title) &&
                        _vm.step == 2 &&
                        !_vm.isOverflow(addonProduct)
                          ? _c("div", { staticClass: "extended-block" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "close",
                                  on: {
                                    click: function() {
                                      _vm.extendedAlert = false
                                    }
                                  }
                                },
                                [_vm._v("X")]
                              ),
                              _vm._v(" "),
                              _vm._m(0, true),
                              _vm._v(" "),
                              _vm._m(1, true)
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isOverflow(addonProduct) &&
                        _vm.overflowAlert &&
                        _vm.step == 2
                          ? _c(
                              "div",
                              {
                                staticClass: "overflow-alert",
                                class: { hidden: !_vm.isProductVisible(index) },
                                style: _vm.getOverflowAlertStyle(index)
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "close cursor-pointer",
                                    on: {
                                      click: function() {
                                        _vm.overflowAlert = false
                                      }
                                    }
                                  },
                                  [_vm._v("X")]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Due to this particular product's size, "
                                  ),
                                  _c("br"),
                                  _vm._v(" the "),
                                  _c("strong", [
                                    _vm._v(_vm._s(addonProduct.title))
                                  ]),
                                  _vm._v(" may be packed "),
                                  _c("br"),
                                  _vm._v(
                                    " outside the Happy Box, in an outer box."
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._m(2, true)
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "addon-container" }, [
                          _c("img", {
                            staticClass: "main-image",
                            attrs: {
                              loading: "lazy",
                              src: _vm.getProductImage(addonProduct)
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: addonProduct.quantity,
                                  expression: "addonProduct.quantity"
                                }
                              ],
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      addonProduct,
                                      "quantity",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.changeOnDemand(addonProduct)
                                  }
                                ]
                              }
                            },
                            _vm._l(_vm.addonMaxQty(addonProduct), function(
                              qty
                            ) {
                              return _c(
                                "option",
                                { key: qty, domProps: { value: qty } },
                                [_vm._v(_vm._s(qty))]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "delete-button",
                            attrs: {
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833"
                            },
                            on: {
                              click: function($event) {
                                return _vm.removeProduct(addonProduct)
                              }
                            }
                          })
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.selectedBoxProduct
                    ? _c("li", [
                        _c("div", { staticClass: "addon-container" }, [
                          _c("img", {
                            staticClass: "main-image",
                            attrs: {
                              loading: "lazy",
                              src: _vm._f("getProductImage")(
                                _vm.selectedBoxProduct
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "edit-container",
                              on: {
                                click: function($event) {
                                  return _vm.goStep(2)
                                }
                              }
                            },
                            [
                              _c("p", [_vm._v("Edit Box")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "switch-button",
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedCardProduct
                    ? _c("li", [
                        _c("div", { staticClass: "addon-container" }, [
                          _c("img", {
                            staticClass: "main-image",
                            attrs: {
                              src: _vm._f("getProductImage")(
                                _vm.selectedCardProduct
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "edit-container",
                              on: {
                                click: function($event) {
                                  return _vm.goStep(3)
                                }
                              }
                            },
                            [
                              _c("p", [_vm._v("Edit Card")]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "switch-button",
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.step != 3
                ? _c(
                    "button",
                    {
                      staticClass: "happybox-button green border m-b-1rem",
                      on: {
                        click: function($event) {
                          return _vm.changePage(true)
                        }
                      }
                    },
                    [_vm._v("Next Step >")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "happybox-button green border m-b-1rem",
                      on: {
                        click: function($event) {
                          return _vm.bundle(false)
                        }
                      }
                    },
                    [_vm._v("Next Step >")]
                  )
            ]
          )
        : _c(
            "div",
            {
              staticClass: "expanded-cart",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "expand-arrow",
                  on: {
                    click: function($event) {
                      return _vm.expandCart(false)
                    }
                  }
                },
                [
                  _c("span", [_vm._v("Collapse")]),
                  _vm._v("\n              >\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "product-summary-container no-scrollbar" },
                [
                  _c("div", { staticClass: "box-name-container" }, [
                    _c("img", {
                      staticClass: "h-auto m-r-05rem",
                      attrs: {
                        width: "20px",
                        height: "20px",
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/gift_blue.svg?v=1749489581"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.boxName,
                          expression: "boxName"
                        }
                      ],
                      staticClass: "body-base placeholder-italic",
                      attrs: {
                        placeholder: "Give Your Box a Name",
                        type: "text",
                        maxlength: "34"
                      },
                      domProps: { value: _vm.boxName },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.editName(false)
                        },
                        blur: function($event) {
                          return _vm.checkName()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.boxName = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product-summary" }, [
                    _c("p", { staticClass: "summary-title" }, [
                      _vm._v("Box Contents")
                    ]),
                    _vm._v(" "),
                    _vm.productQtyCopy
                      ? _c("p", { staticClass: "summary-subtitle" }, [
                          _vm._v(_vm._s(_vm.productQtyCopy))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "products-container" },
                      [
                        _vm._l(_vm.selectedAddonProducts, function(
                          addonProduct
                        ) {
                          return _c(
                            "li",
                            { key: addonProduct.variants[0].id },
                            [
                              _c("div", { staticClass: "addon-container" }, [
                                _c("div", { staticClass: "image-container" }, [
                                  _c("img", {
                                    staticClass: "main-image lazyload",
                                    attrs: {
                                      width: "100",
                                      height: "100",
                                      loading: "lazy",
                                      src: _vm.getProductImage(addonProduct)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openModalProduct(
                                          addonProduct
                                        )
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "product-information" },
                                  [
                                    _c("div", [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "title",
                                          on: {
                                            click: function($event) {
                                              return _vm.openModalProduct(
                                                addonProduct
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(addonProduct.title))]
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "price" }, [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              addonProduct.variants[0].price
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "product-qty-container" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: addonProduct.quantity,
                                                expression:
                                                  "addonProduct.quantity"
                                              }
                                            ],
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    addonProduct,
                                                    "quantity",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                                function($event) {
                                                  return _vm.changeOnDemand(
                                                    addonProduct
                                                  )
                                                }
                                              ]
                                            }
                                          },
                                          _vm._l(
                                            _vm.addonMaxQty(addonProduct),
                                            function(qty) {
                                              return _c(
                                                "option",
                                                {
                                                  key: qty,
                                                  domProps: { value: qty }
                                                },
                                                [_vm._v(_vm._s(qty))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticClass: "delete-button",
                                          attrs: {
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeProduct(
                                                addonProduct
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.selectedBoxProduct
                          ? _c("li", [
                              _c("div", { staticClass: "addon-container" }, [
                                _c("div", { staticClass: "image-container" }, [
                                  _c("img", {
                                    staticClass: "main-image lazyload",
                                    attrs: {
                                      width: "100",
                                      height: "100",
                                      src: _vm._f("getProductImage")(
                                        _vm.selectedBoxProduct
                                      )
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "product-information" },
                                  [
                                    _c("div", [
                                      _c("p", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(_vm.selectedBoxProduct.title)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "price" }, [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              _vm.selectedBoxProduct.variants[0]
                                                .price
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "product-qty-container" },
                                      [
                                        _c("img", {
                                          staticClass: "switch-button",
                                          attrs: {
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goStep(2)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedCardProduct
                          ? _c("li", [
                              _c("div", { staticClass: "addon-container" }, [
                                _c("div", { staticClass: "image-container" }, [
                                  _c("img", {
                                    staticClass: "main-image lazyload",
                                    attrs: {
                                      width: "100",
                                      height: "100",
                                      src: _vm._f("getProductImage")(
                                        _vm.selectedCardProduct
                                      )
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "product-information" },
                                  [
                                    _c("div", [
                                      _c("p", { staticClass: "title" }, [
                                        _vm._v(
                                          _vm._s(_vm.selectedCardProduct.title)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "price" }, [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              _vm.selectedCardProduct
                                                .variants[0].price
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "product-qty-container" },
                                      [
                                        _c("img", {
                                          staticClass: "switch-button",
                                          attrs: {
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goStep(3)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "remove-all color-link underline  flex flex-align-center flex-justify-between gap-05vw",
                        on: {
                          click: function($event) {
                            return _vm.goStep(1)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "h-auto",
                          attrs: {
                            width: "15px",
                            height: "10px",
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/edit.svg?v=1749479131"
                          }
                        }),
                        _vm._v(
                          "\n                      Edit gifts\n                  "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-container" }, [
                    _c("div", { staticClass: "box-qty-container" }, [
                      _c("p", [_vm._v("Box Quantity")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-qty-input-container" }, [
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.incrementBoxQty(false)
                              }
                            }
                          },
                          [_vm._v("-")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedBoxQty,
                              expression: "selectedBoxQty"
                            }
                          ],
                          attrs: { type: "number", min: "1" },
                          domProps: { value: _vm.selectedBoxQty },
                          on: {
                            blur: function($event) {
                              return _vm.changeBoxQty(null)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.selectedBoxQty = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.incrementBoxQty(true)
                              }
                            }
                          },
                          [_vm._v("+")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "multiship-notice" }, [
                      _vm._v(
                        "Adjust the quantity if you'd like duplicates of this box, even if you're shipping to different addresses!"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.customAlert && _vm.hasCustomProducts
                      ? _c("p", { staticClass: "custom-notice" }, [
                          _vm._v(_vm._s(_vm.customAlert))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.recommendedAddons.length > 0
                    ? _c("div", { staticClass: "recommendation-container" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Perfect fit for your box")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "recommended-addon-container" },
                          _vm._l(_vm.recommendedAddons, function(addon) {
                            return _c(
                              "div",
                              {
                                key: addon.id,
                                staticClass: "recommended-addon"
                              },
                              [
                                _c("img", {
                                  staticClass: "main-image",
                                  attrs: {
                                    width: "180",
                                    height: "180",
                                    loading: "lazy",
                                    src: addon.image.src
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openModalProduct(addon)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "happybox-button white border",
                                    on: {
                                      click: function($event) {
                                        return _vm.updateReccomendedAddonProductQuantity(
                                          addon
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.addCopy))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "addon-title",
                                    on: {
                                      click: function($event) {
                                        return _vm.openModalProduct(addon)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(addon.title))]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "price" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("moneySaleFormat")(
                                        addon.variants[0].price
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price-summary-container no-scrollbar" },
                [
                  _c("div", { staticClass: "x-container" }, [
                    _c("img", {
                      staticClass: "x-button",
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                        alt: "x"
                      },
                      on: {
                        click: function($event) {
                          return _vm.expandCart(false)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-container" }, [
                    _c("div", { staticClass: "item-summary" }, [
                      _c("p", { staticClass: "item-title" }, [
                        _vm._v("Box Summary")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-total" }, [
                        _c("div", { staticClass: "total-container" }, [
                          _vm.boxQty > 1
                            ? _c("p", { staticClass: "title" }, [
                                _c("strong", [
                                  _vm._v("(" + _vm._s(_vm.boxQty) + ")")
                                ]),
                                _vm._v(" " + _vm._s(_vm.boxName))
                              ])
                            : _c("p", { staticClass: "title" }, [
                                _vm._v(_vm._s(_vm.boxName))
                              ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "price" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("moneySaleFormat")(
                                  _vm.gifsPrice * _vm.boxQty
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "individual-price" }, [
                          _vm._v(
                            _vm._s(_vm._f("moneySaleFormat")(_vm.gifsPrice)) +
                              " per box"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-total" }, [
                        _c("div", { staticClass: "total-container" }, [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("Gift Box Design "),
                            !_vm.selectedBoxProduct
                              ? _c("span", [_vm._v("(selected at next step)")])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.selectedBoxProduct
                            ? _c("p", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moneySaleFormat")(
                                      _vm.boxPrice * _vm.boxQty
                                    )
                                  )
                                )
                              ])
                            : _c("p", { staticClass: "price" }, [_vm._v("$--")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-total" }, [
                        _c("div", { staticClass: "total-container" }, [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("Card "),
                            !_vm.selectedCardProduct
                              ? _c("span", [
                                  _vm._v("(selected at future step)")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.selectedCardProduct
                            ? _c("p", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moneySaleFormat")(
                                      _vm.cardPrice * _vm.boxQty
                                    )
                                  )
                                )
                              ])
                            : _c("p", { staticClass: "price" }, [_vm._v("$--")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-total" }, [
                        _c("div", { staticClass: "total-container" }, [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("Handpacking Fee")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "price" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("moneySaleFormat")(
                                  _vm.feePrice * _vm.boxQty
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.hasOnDemandProducts
                          ? _c("p", { staticClass: "purple-legend" }, [
                              _vm._v(
                                " Some items in your cart may  require 1-2 week lead time.  But trust us, they're worth the wait!"
                              )
                            ])
                          : _vm.hasCustomProducts
                          ? _c("p", { staticClass: "individual-price" }, [
                              _vm._v(
                                "Custom items require a lead time of at least 1-2 weeks. Our team will reach out via email to coordinate shipping details."
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-total" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Item Total")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "price" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moneySaleFormat")(
                                _vm.totalPrice * _vm.boxQty
                              )
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "separator" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "subtotal-container" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Estimated Subtotal")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneySaleFormat")(
                              _vm.totalPrice * _vm.boxQty
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.step != 3
                    ? _c("div", { staticClass: "complete-box" }, [
                        _c(
                          "button",
                          {
                            staticClass: "hb-btn primary",
                            class: _vm.isloading ? "isLoading" : "",
                            on: {
                              click: function($event) {
                                return _vm.changePage(true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.canCopy))]
                        )
                      ])
                    : _c("div", { staticClass: "complete-box" }, [
                        _c(
                          "button",
                          {
                            staticClass: "hb-btn primary",
                            class: _vm.isloading ? "isLoading" : "",
                            on: {
                              click: function($event) {
                                return _vm.bundle(false)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.bundleText))]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "color-link underline body-base",
                            on: {
                              click: function($event) {
                                return _vm.bundle(true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.bundleSecondaryText))]
                        )
                      ])
                ]
              )
            ]
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v("Swap this gift for a smaller one to view cheaper box options")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-t" }, [
      _c("div", { staticClass: "inner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-t" }, [
      _c("div", { staticClass: "inner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notice-container" }, [
      _c("img", {
        staticClass: "main-image",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/boxwings.svg?v=1658459692"
        }
      }),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticClass: "title" }, [
          _vm._v("Multiple addresses? No problem!")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v("Ship to one or many locations all "),
          _c("br"),
          _vm._v(" in one, easy checkout")
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://www.loom.com/share/d6c4740fe5534425a14581d913b91910?sid=672876ae-7e19-49bd-b06a-b75f17df94ac"
            }
          },
          [_vm._v("Watch the Demo")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "taxes-container" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("Taxes "),
        _c("strong", [_vm._v("(calculated in checkout)")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "price" }, [_vm._v("--")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }